import {Injectable} from "@angular/core";
import {APIPageInfo, GQLPagingParamsVariable, GRAPHQL_TYPES, HttpUtilityService, PagedModelFetchFn, PagingParams} from "../http-utility-service";
import {MainSustainabilityRatingAttribute, MainSustainabilityRatingAttributeImpl} from "./ratings/sustainability-ratings.interface";
import * as gql from 'gql-query-builder';
import {BaseService} from "../base-service";
import {Observable} from "rxjs";


export interface SustainabilityRatingAttributeSearchTerm {
  msra_id?: number;
  msra_ids?: number[];
}

export interface SustainabilityRatingAttributeFullSearchTerm extends SustainabilityRatingAttributeSearchTerm, PagingParams {}

const sustainabilityRatingAttributeOperation = 'main_sustainability_rating_attributes';

const sustainabilityRatingAttributeVariables = {
  msra_id: {type: GRAPHQL_TYPES.INTEGER},
  msra_ids: {type: GRAPHQL_TYPES.INTEGER, list: true},
  ...GQLPagingParamsVariable
};

const sustainabilityRatingAttributeFields = [
  'msra_id',
  'name_key'
];

@Injectable({providedIn: 'root'})
export class SustainabilityRatingAttributeService extends BaseService {
  public static readonly modelMapping = {SustainabilityRatingAttribute: MainSustainabilityRatingAttributeImpl};

  private readonly FETCH_PAGE_SIZE: number = 500;
  private readonly DATA_KEY = sustainabilityRatingAttributeOperation;
  private readonly sustanabilityRatingAttributeQuery = gql.query({
    operation: sustainabilityRatingAttributeOperation,
    fields: sustainabilityRatingAttributeFields,
    variables: sustainabilityRatingAttributeVariables
  });

  constructor(private httpUtilityService: HttpUtilityService) {
    super();
  }

  getAllSustainabilityRatingAttributes(): Observable<MainSustainabilityRatingAttribute[]> {
    const request: PagedModelFetchFn<MainSustainabilityRatingAttribute[]> = (pageInfo: APIPageInfo) => {
      const params: SustainabilityRatingAttributeFullSearchTerm = {start_index: pageInfo.first, limit: pageInfo.rows};
      return this.httpUtilityService.graphQL(this.sustanabilityRatingAttributeQuery, this.DATA_KEY, params);
    };
    return this.httpUtilityService.pageUntilComplete(request, {first: 0, rows: this.FETCH_PAGE_SIZE});
  }
}